//# sourceMappingURL=keyframes.mjs.map
/// <reference types="./keyframes.d.mts" />
import * as $css from "../../../sketch/sketch/css.mjs";
import * as $angle from "../../../sketch/sketch/css/angle.mjs";
import * as $keyframe from "../../../sketch/sketch/css/keyframe.mjs";
import * as $length from "../../../sketch/sketch/css/length.mjs";
import { percent, px } from "../../../sketch/sketch/css/length.mjs";
import * as $transform from "../../../sketch/sketch/css/transform.mjs";
import { toList } from "../../gleam.mjs";

function translate_x(value) {
  let transform = $transform.translate_x(percent(value));
  return $css.transform(toList([transform]));
}

export function wave() {
  return $css.keyframes(
    "wave",
    toList([
      $keyframe.at(0, toList([translate_x(-100)])),
      $keyframe.at(50, toList([translate_x(0)])),
      $keyframe.at(100, toList([translate_x(100)])),
    ]),
  );
}

export function pulse() {
  return $css.keyframes(
    "pulse",
    toList([
      $keyframe.at(0, toList([$css.opacity(1.0)])),
      $keyframe.at(50, toList([$css.opacity(0.4)])),
      $keyframe.at(100, toList([$css.opacity(1.0)])),
    ]),
  );
}

export function fading_text() {
  return $css.keyframes(
    "fading-text",
    toList([
      $keyframe.at(0, toList([$css.opacity(0.0), translate_x(-30)])),
      $keyframe.at(2, toList([$css.opacity(1.0), translate_x(-50)])),
      $keyframe.at(18, toList([$css.opacity(1.0), translate_x(-50)])),
      $keyframe.at(20, toList([$css.opacity(0.0), translate_x(-80)])),
      $keyframe.at(100, toList([$css.opacity(0.0), translate_x(-80)])),
    ]),
  );
}

export function dot_appear() {
  return $css.keyframes(
    "dot-appear",
    toList([
      $keyframe.from(
        toList([$css.transform(toList([$transform.scale(0.0, 0.0)]))]),
      ),
      $keyframe.to(
        toList([$css.transform(toList([$transform.scale(1.0, 1.0)]))]),
      ),
    ]),
  );
}

export function text_appear() {
  return $css.keyframes(
    "text-appear",
    toList([
      $keyframe.from(toList([$css.background_position("100% center")])),
      $keyframe.to(toList([$css.background_position("0% center")])),
    ]),
  );
}

export function text_gradient() {
  return $css.keyframes(
    "text-gradient",
    toList([
      $keyframe.from(toList([$css.background_position("200% center")])),
      $keyframe.to(toList([$css.background_position("0% center")])),
    ]),
  );
}

function rotate(degrees) {
  return $css.transform(toList([$transform.rotate($angle.deg(degrees))]));
}

export function bell_rock() {
  return $css.keyframes(
    "bell-rock",
    toList([
      $keyframe.at(0, toList([rotate(0.0)])),
      $keyframe.at(15, toList([rotate(14.0)])),
      $keyframe.at(30, toList([rotate(-10.0)])),
      $keyframe.at(45, toList([rotate(6.0)])),
      $keyframe.at(60, toList([rotate(-3.0)])),
      $keyframe.at(75, toList([rotate(0.0)])),
      $keyframe.at(100, toList([rotate(0.0)])),
    ]),
  );
}

export function z_drift() {
  return $css.keyframes(
    "z-drift",
    toList([
      $keyframe.at(
        0,
        toList([
          $css.opacity(0.0),
          $css.transform(toList([$transform.translate(px(0), px(6))])),
        ]),
      ),
      $keyframe.at(25, toList([$css.opacity(1.0)])),
      $keyframe.at(
        100,
        toList([
          $css.opacity(0.0),
          $css.transform(toList([$transform.translate(px(6), px(-14))])),
        ]),
      ),
    ]),
  );
}

export function ring_pulse() {
  return $css.keyframes(
    "ring-pulse",
    toList([
      $keyframe.from(
        toList([
          $css.opacity(0.5),
          $css.transform(toList([$transform.scale(1.0, 1.0)])),
        ]),
      ),
      $keyframe.to(
        toList([
          $css.opacity(0.0),
          $css.transform(toList([$transform.scale(1.6, 1.6)])),
        ]),
      ),
    ]),
  );
}

export function spin() {
  return $css.keyframes(
    "spin",
    toList([
      $keyframe.from(
        toList([$css.transform(toList([$transform.rotate($angle.deg(0.0))]))]),
      ),
      $keyframe.to(
        toList([$css.transform(toList([$transform.rotate($angle.deg(360.0))]))]),
      ),
    ]),
  );
}
